export var AssetStoreEvent;
(function (AssetStoreEvent) {
    AssetStoreEvent["UploadStart"] = "assetStoreUploadStart";
    AssetStoreEvent["UploadSuccess"] = "assetStoreUploadSuccess";
    AssetStoreEvent["UploadError"] = "assetStoreUploadError";
    AssetStoreEvent["ImageInfoServerSuccess"] = "ImageInfoServerSuccess";
    AssetStoreEvent["ImageInfoServerFailure"] = "ImageInfoServerFailure";
    AssetStoreEvent["ImageInfoClientSuccess"] = "ImageInfoClientSuccess";
    AssetStoreEvent["ImageInfoClientFailure"] = "ImageInfoClientFailure";
    AssetStoreEvent["NewlyUploadedAssetPollingSuccess"] = "NewlyUploadedAssetPollingSuccess";
    AssetStoreEvent["NewlyUploadedAssetPollingFailure"] = "NewlyUploadedAssetPollingFailure";
    AssetStoreEvent["UploadUsingSignedUrlFailure"] = "UploadUsingSignedUrlFailure";
    AssetStoreEvent["DocumentItemInfoSuccess"] = "DocumentItemInfoSuccess";
    AssetStoreEvent["DocumentItemInfoFailure"] = "DocumentItemInfoFailure";
})(AssetStoreEvent || (AssetStoreEvent = {}));
//# sourceMappingURL=types.js.map